import { MessageDetails } from '@shared/tokens/api-messages';
import { ApiMessagingService } from '../api-messaging.service';

export class ApiGatewayError extends Error {
  static key = 'unknown';

  staticFields = Object.getPrototypeOf(this).constructor;
  scope?: string;

  constructor(
    protected messageService: ApiMessagingService,
    public override cause?: Error,
    protected record?: Record<string, any>
  ) {
    super();
    // Keeps the existing error type and info after wrapping the error once
    if (this.cause instanceof ApiGatewayError) return this.cause;
    // Due to returned proto not always matching the calling class, subclasses should avoid
    // overriding the constructor, and should instead use lifecycle methods.
    return this.buildInstance();
  }

  private _key?: string;

  get key(): string {
    return this._key || this.staticFields.key;
  }

  set key(value: string) {
    this._key = value;
  }

  override get message(): string {
    return this.messageService.message(this.key, this.details, {
      scope: this.scope,
      default: ApiGatewayError.key,
    });
  }

  override get name() {
    return this.cause?.message
      ? `${this.staticFields.name}: ${this.cause?.message}`
      : this.staticFields.name;
  }

  get details(): MessageDetails {
    return { record: this.record };
  }

  buildInstance(): ApiGatewayError {
    return this;
  }
}
